

// when diff user logs in then we clear local storage to avoid data mix up between two users

 function deleteLocalStorage() {
    console.log("Deleting local storage data for previous user");
      localStorage.removeItem("id");
      localStorage.removeItem("staffRegister");
      localStorage.removeItem("branches");
      localStorage.removeItem("pdata");
      localStorage.removeItem("questions");
      localStorage.removeItem("summaryData");
      localStorage.removeItem("summaryDataLatestDate");
}
module.exports = {deleteLocalStorage};